import { createEntityAdapter, EntityState } from "@ngrx/entity";
import { createReducer, on } from "@ngrx/store";
import {
  TreatmentPageActions,
  TreatmentPlanApiActions,
} from "../actions/action-index";
import { TreatmentNotification } from "./models/treatment-notification";

export const featureKey = "treatmentNotifications";

export type TreatmentNotificationState = EntityState<TreatmentNotification>

export const adapter = createEntityAdapter<TreatmentNotification>({
  selectId: (notification) =>
    `${notification.treatmentPlanId}${notification.notificationTemplateId}${notification.insurancePolicyPatientEligibilityId}`,
});

export const initialState: TreatmentNotificationState = adapter.getInitialState();

export const reducer = createReducer(
  initialState,
  on(
    TreatmentPlanApiActions.loadNotificationsSuccess,
    (state, { notifications }) => {
      const treatmentPlanIds = new Set(notifications.map(n => n.TreatmentPlanId));

      state = adapter.removeMany(
        Object.keys(state.entities).filter(
          (k) => treatmentPlanIds.has(state.entities[k].treatmentPlanId)
        ),
        state
      );
      return adapter.addMany(notifications.map(
        (n) =>
          ({
            notificationLevelId: n.NotificationLevelId,
            notificationTemplateId: n.NotificationTemplateId,
            treatmentPlanId: n.TreatmentPlanId,
            description: n.AlertDescription,
            insurancePolicyPatientEligibilityId:
            n.InsurancePolicyPatientEligibilityId,
            title: n.AlertTitle,
          } as TreatmentNotification)
        )
        ,state);
    }
  ),
  on(TreatmentPageActions.treatmentPlanRemoved, (state, { id }) =>
    adapter.removeMany(
      Object.keys(state.entities).filter(
        (k) => state.entities[k].treatmentPlanId === id
      ),
      state
    )
  )
);
